"use client";
import { jsxs as o, jsx as e } from "react/jsx-runtime";
function t() {
  return /* @__PURE__ */ o(
    "svg",
    {
      viewBox: "0 0 12 10",
      style: {
        width: "1.2em",
        fill: "none",
        strokeWidth: 2,
        stroke: "currentColor",
        strokeDasharray: 16
      },
      children: [
        /* @__PURE__ */ e("title", { children: "Checkbox Icon" }),
        /* @__PURE__ */ e("polyline", { points: "1.5 6 4.5 9 10.5 1" })
      ]
    }
  );
}
export {
  t as CheckboxIcon
};
